export const ALLOWED_EXTENSIONS = [
  "pdf",
  "txt",
  "doc",
  "docx",
  "rtf",
  "epub",
  "html",
  "htm",
  "md",
  "markdown",
  "pptx",
  "xlsx",
  "odt",
  "csv",
]

export const ALLOWED_IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "heic", "heif"]

export const ALLOWED_IMAGE_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/heic",
  "image/heif",
]
